// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-fake[data-v-28a90ae6] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #ffffff;\n  border: 1px solid #ccc;\n  pointer-events: none;\n  z-index: 1;\n}", ""]);
// Exports
module.exports = exports;
